import styled from "styled-components";

export const StyledTranslationContainer = styled.div`
  #google_translate_element {
    display: block;
  }
`;
